module.exports = __webpack_public_path__ + "img/6d46b96.jpg";